
define('text!ShareTools/appTemplate',[],function () { return '<div class="quiz_share">\n    <button class="quiz_share__button quiz_share__button--app share__tool--network" data-network="app"><%=label %></button>\n</div>\n';});

